import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserNotAltered = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18.775 20.6258L16.15 18.0008H3V15.2008C3 14.6341 3.146 14.1134 3.438 13.6388C3.73 13.1641 4.11733 12.8014 4.6 12.5508C5.35 12.1674 6.11267 11.8591 6.888 11.6258C7.66333 11.3924 8.45067 11.2174 9.25 11.1008L0.375 2.22578L1.8 0.800781L20.2 19.2008L18.775 20.6258ZM5 16.0008H14.15L11.15 13.0008H11C10.0667 13.0008 9.14167 13.1134 8.225 13.3388C7.30833 13.5641 6.4 13.9014 5.5 14.3508C5.35 14.4341 5.229 14.5508 5.137 14.7008C5.045 14.8508 4.99933 15.0174 5 15.2008V16.0008ZM17.4 12.5508C17.8833 12.7841 18.2667 13.1384 18.55 13.6138C18.8333 14.0891 18.9833 14.6014 19 15.1508L15.65 11.8008C15.95 11.9174 16.246 12.0341 16.538 12.1508C16.83 12.2674 17.1173 12.4008 17.4 12.5508ZM13.2 9.35078L11.725 7.87578C12.1083 7.72578 12.4167 7.48011 12.65 7.13878C12.8833 6.79745 13 6.41811 13 6.00078C13 5.45078 12.8043 4.98011 12.413 4.58878C12.0217 4.19745 11.5507 4.00145 11 4.00078C10.5833 4.00078 10.2043 4.11745 9.863 4.35078C9.52167 4.58411 9.27567 4.89245 9.125 5.27578L7.65 3.80078C8.03333 3.23411 8.51667 2.79245 9.1 2.47578C9.68333 2.15911 10.3167 2.00078 11 2.00078C12.1 2.00078 13.0417 2.39245 13.825 3.17578C14.6083 3.95911 15 4.90078 15 6.00078C15 6.68411 14.8417 7.31745 14.525 7.90078C14.2083 8.48411 13.7667 8.96745 13.2 9.35078Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgUserNotAltered);
export { ForwardRef as ReactComponent };
